// Wording shared across the calculator pages, kept in one place so Legal can review it together.
// This mirrors the copy in rhea-egg-calc-embed (branch sg-legal-review, src/lang/en/eggfreeze.json).

export const copy = {
  title: 'Egg Freezing Explorer',

  formIntro:
    "See how outcomes vary across our dataset. Enter a few details and we'll show modelled egg retrieval and live-birth outcomes for people with similar characteristics, after 1, 2 and 3 cycles. This is a general information tool, not a prediction of your own results. For a personalized medical assessment, schedule a consultation with us.",

  notice: {
    title: 'Before you start',
    body: "This tool uses general information from population data. It does not assess or predict your fertility, health or treatment outcome, and it isn't medical advice. It does not recommend whether, when or how many treatment cycles you should undergo, and should not be used to make a medical or treatment decision. For medical advice about your own situation, please schedule a consultation with one of our doctors.",
  },

  amhUnknown: {
    message: "That's OK, you can continue without it.",
    recommendation:
      'Without an AMH result, the figures reflect a broader group in the dataset. A doctor can tell you more about AMH testing.',
  },

  ageError: 'Please enter an age between 20 and 45',

  results: {
    title: 'What the data shows for people with similar characteristics',
    leadIn:
      'These figures show modelled outcomes for people with similar characteristics to the details you entered. They describe a statistical analysis and they are not a prediction of your individual outcome.',
    cycleLabel: 'After',
    outcomeLabel: 'Modelled outcome',
    cycleComparison:
      'Comparing 1, 2 and 3 cycles shows how modelled outcomes change with more cycles. It does not indicate how many cycles you should undergo or whether any number of cycles is suitable for you.',
    disclaimerTitle: 'About these figures',
    disclaimer:
      'This is a general educational tool. The figures come from population data and are filtered by the details you entered. They are not an assessment, diagnosis, or prediction of your fertility or ovarian reserve. Actual outcomes vary between individuals and treatment cycles, and may differ materially from the figures shown. You should not rely on these figures to decide whether or when to freeze your eggs, or to delay seeking medical advice. Schedule an appointment with one of our doctors to get a personalized recommendation.',
    whyManyEggs: 'Why does it take many eggs to reach one live birth?',
    methodology:
      'Read more about the data and methodology behind these figures',
  },

  process: {
    title: 'Why does it take many eggs to reach one live birth?',
    description:
      'At each step of IVF, from retrieval to freezing, thawing, fertilisation and transfer, some eggs do not continue to the next step. This is a normal part of the process, and it is why more than one egg is usually needed for each live birth. Below is a step-by-step example of an IVF cycle attrition rate from egg retrieval to live birth.',
    subtitle: 'How egg numbers typically fall at each step of the process',
  },

  // {region}, {min}, {max} are filled from the REACT_APP_ELIGIBILITY_* settings (see utils/config.ts).
  eligibility:
    'In {region}, elective egg freezing is generally available to women who are at least {min} but below {max} years of age. Eligibility and medical suitability are assessed separately by a fertility specialist.',
  eligibilityAge:
    'You entered an age of {age}. In {region}, elective egg freezing is generally available to women who are at least {min} but below {max} years of age. These figures do not confirm that treatment is available to you at this age.',
};
